<template>
  <div class="p-4 pb-1">
    <h3 class="font-weight-bold my-auto pb-2">Preise</h3>
		
		<div v-if="fetchingArticle && !articleObj" class="w-100 d-flex justify-content-center">
			<b-spinner variant="primary" class="m-3"/>
		</div>
		<b-alert v-else-if="error" class="mt-5 text-center" variant="danger" show>
			{{error}}
		</b-alert>
		<div v-else v-html="articleObj.htmlContent" class="ck-content"></div>

    <!-- Mobile tables -->
    <!-- <b-row class="my-3 d-sm-none" align-h="center">
      <b-col class="mb-4">
        <b-card no-body class="shadow-sm" >
          <div class="w-100 d-flex justify-content-center bg-default">
            <h5 class="my-2">
              <b>Verkauf</b>
            </h5>
          </div>
          <b-table-simple responsive class="mb-0">
            <b-thead>
              <b-tr>
                <b-th></b-th>
                <b-th>Ohne Rahmen</b-th>
                <b-th>Mit Rahmen</b-th>
              </b-tr>
            </b-thead>
            <b-tbody>
              <b-tr>
                <b-th>S</b-th>
                <b-td>8,00€</b-td>
                <b-td>-</b-td>
              </b-tr>
              <b-tr>
                <b-th>M</b-th>
                <b-td>14,00€</b-td>
                <b-td>24,00€</b-td>
              </b-tr>
              <b-tr>
                <b-th>L</b-th>
                <b-td>22,00€</b-td>
                <b-td>40,00€</b-td>
              </b-tr>
              <b-tr>
                <b-th>XL</b-th>
                <b-td>27,00€</b-td>
                <b-td>48,00€</b-td>
              </b-tr>
              <b-tr>
                <b-th>XXL</b-th>
                <b-td>32,00€</b-td>
                <b-td>57,00€</b-td>
              </b-tr>
            </b-tbody>
          </b-table-simple>
        </b-card>
      </b-col>
      <b-col class="d-flex justify-content-center flex-column mb-4">
        <b-card no-body class="shadow-sm">
          <div class="w-100 d-flex justify-content-center bg-default">
            <h5 class="my-2">
              <b>Vermietung</b>
            </h5>
          </div>
          <b-table-simple responsive class="mb-0">
            <b-thead>
              <b-tr>
                <b-th></b-th>
                <b-th>1-3 Bilder</b-th>
                <b-th>4-6 Bilder</b-th>
                <b-th>>6 Bilder</b-th>
              </b-tr>
            </b-thead>
            <b-tbody>
              <b-tr>
                <b-th>S</b-th>
                <b-td>3,00€</b-td>
                <b-td>2,50€</b-td>
                <b-td>2,00€</b-td>
              </b-tr>
              <b-tr>
                <b-th>M</b-th>
                <b-td>3,50€</b-td>
                <b-td>3,00€</b-td>
                <b-td>2,50€</b-td>
              </b-tr>
              <b-tr>
                <b-th>L</b-th>
                <b-td>4,00€</b-td>
                <b-td>3,50€</b-td>
                <b-td>3,00€</b-td>
              </b-tr>
              <b-tr>
                <b-th>S</b-th>
                <b-td>5,50€</b-td>
                <b-td>5,00€</b-td>
                <b-td>4,50€</b-td>
              </b-tr>
              <b-tr>
                <b-th>S</b-th>
                <b-td>3,00€</b-td>
                <b-td>2,50€</b-td>
                <b-td>2,00€</b-td>
              </b-tr>
            </b-tbody>
          </b-table-simple>
        </b-card>
        <small class="mx-auto mt-2">Preis pro Bild pro Monat, inklusive Rahmen</small>
      </b-col>
    </b-row> -->

    <!-- Desktop tables -->
    <!-- <b-row class="my-3 d-none d-sm-flex" align-h="center">
      <b-col class="mb-4">
        <b-card no-body class="shadow-sm" >
          <div class="w-100 d-flex justify-content-center bg-default">
            <h5 class="my-2">
              <b>Verkauf</b>
            </h5>
          </div>
          <b-table-simple responsive class="mb-0">
            <b-thead>
              <b-tr>
                <b-th></b-th>
                <b-th>S</b-th>
                <b-th>M</b-th>
                <b-th>L</b-th>
                <b-th>XL</b-th>
                <b-th>XXL</b-th>
              </b-tr>
            </b-thead>
            <b-tbody>
              <b-tr>
                <b-th>Ohne Rahmen</b-th>
                <b-td>8€</b-td>
                <b-td>14€</b-td>
                <b-td>22€</b-td>
                <b-td>27€</b-td>
                <b-td>32€</b-td>
              </b-tr>
              <b-tr>
                <b-th>Mit Rahmen</b-th>
                <b-td>-</b-td>
                <b-td>24€</b-td>
                <b-td>40€</b-td>
                <b-td>48€</b-td>
                <b-td>57€</b-td>
              </b-tr>
            </b-tbody>
          </b-table-simple>
        </b-card>
      </b-col>
      <b-col class="d-flex justify-content-center flex-column mb-4">
        <b-card no-body class="shadow-sm">
          <div class="w-100 d-flex justify-content-center bg-default">
            <h5 class="my-2">
              <b>Vermietung</b>
            </h5>
          </div>
          <b-table-simple responsive class="mb-0">
            <b-thead>
              <b-tr>
                <b-th></b-th>
                <b-th>S</b-th>
                <b-th>M</b-th>
                <b-th>L</b-th>
                <b-th>XL</b-th>
              </b-tr>
            </b-thead>
            <b-tbody>
              <b-tr>
                <b-th>1-3 Bilder</b-th>
                <b-td>3,00€</b-td>
                <b-td>3,50€</b-td>
                <b-td>4,00€</b-td>
                <b-td>5,50€</b-td>
              </b-tr>
              <b-tr>
                <b-th>4-6 Bilder</b-th>
                <b-td>2,50€</b-td>
                <b-td>3,00€</b-td>
                <b-td>3,50€</b-td>
                <b-td>5,00€</b-td>
              </b-tr>
              <b-tr>
                <b-th>>6 Bilder</b-th>
                <b-td>2,00€</b-td>
                <b-td>2,50€</b-td>
                <b-td>3,00€</b-td>
                <b-td>4,50€</b-td>
              </b-tr>
            </b-tbody>
          </b-table-simple>
        </b-card>
        <small class="mx-auto mt-2">Preis pro Bild pro Monat, inklusive Rahmen</small>
      </b-col>
    </b-row> -->

    <!-- <b-row align-h="center" class="mb-4">
      <b-col cols="auto">
        <b>Größen (in cm):</b>
      </b-col>
      <b-col cols="auto">
        S: 20x30
      </b-col>
      <b-col cols="auto">
        M: 30x40-45
      </b-col>
      <b-col cols="auto">
        L: 40x50-60
      </b-col>
      <b-col cols="auto">
        XL: 50x60-75
      </b-col>
      <b-col cols="auto">
        XXL: 60x75
      </b-col>
    </b-row> -->

    <!-- <div class="w-100 d-flex justify-content-center">
      <b-card class="mt-3 mb-2 p-3 d-inline-flex flex-row align-items-center bg-default shadow-sm" no-body>
        <b-icon-info-circle />
        <div class="ml-3 d-inline-block" style="line-height: 0.9">
          <p class="mb-2">
            <small>Alle Preise zuzüglich Versandkosten</small>
          </p>
          <p class="mb-1">
            <small>Preise von Kunstwerken werden individuell bestimmt</small>
          </p>
        </div>
      </b-card>
    </div> -->
  </div>
</template>

<script>
export default {
	data() {
		return {
			fetchingArticle: true,
			error: '',
			articleObj: null,
		}
	},
	mounted() {
		this.articleObj = JSON.parse(localStorage.getItem('prices')) ?? null;
		this.fetchArticle();
	},
	methods: {
    fetchArticle: async function() {
      this.fetchingArticle = true;
      this.error = '';

      try {
        let result = await this.axios.get('/api/article', {
          params: {
            special: 'prices'
          }
        });
				
        this.articleObj = result.data;

				// save cache
				localStorage.setItem('prices', JSON.stringify(this.articleObj));
      } catch (error) {
        console.log(error);
        this.error = 'Fehler beim Laden des Artikels';
      }

			if(process.env.NODE_ENV === 'development') {
        this.error = null;

				// eslint-disable-next-line no-useless-escape
				this.articleObj = {"id":"5","title":"Preise","year":"-1","visible":true,"publishDate":null,"isSpecial":"prices","editSource":true,"preview":"\n\t.table {\n    margin: 0 !important;\n  }\n\n\n\n\n  \n    \n      \n        \n          Verkauf\n        \n      \n      \n        \n          \n            \n              \n              Ohne Rahmen\n","htmlContent":"<style type=\"text\/css\" scoped>\n\t.table {\n    margin: 0 !important;\n  }\n<\/style>\n\n<!-- Mobile tables -->\n<div class=\"row justify-content-center my-3 d-sm-none\">\n  <div class=\"col mb-4\">\n    <div class=\"shadow-sm card\" >\n      <div class=\"w-100 d-flex justify-content-center bg-light\">\n        <h5 class=\"my-2\">\n          <b>Verkauf<\/b>\n        <\/h5>\n      <\/div>\n      <div class=\"table-responsive\">\n        <table class=\"table mb-0\">\n          <thead>\n            <tr>\n              <th><\/th>\n              <th>Ohne Rahmen<\/th>\n              <th>Mit Rahmen<\/th>\n            <\/tr>\n          <\/thead>\n          <tbody>\n            <tr>\n              <th>S<\/th>\n              <td>8,00\u20ac<\/td>\n              <td>-<\/td>\n            <\/tr>\n            <tr>\n              <th>M<\/th>\n              <td>14,00\u20ac<\/td>\n              <td>24,00\u20ac<\/td>\n            <\/tr>\n            <tr>\n              <th>L<\/th>\n              <td>22,00\u20ac<\/td>\n              <td>40,00\u20ac<\/td>\n            <\/tr>\n            <tr>\n              <th>XL<\/th>\n              <td>27,00\u20ac<\/td>\n              <td>48,00\u20ac<\/td>\n            <\/tr>\n            <tr>\n              <th>XXL<\/th>\n              <td>32,00\u20ac<\/td>\n              <td>57,00\u20ac<\/td>\n            <\/tr>\n          <\/tbody>\n        <\/table>\n      <\/div>\n    <\/div>\n  <\/div>\n  <div class=\"col d-flex justify-content-center flex-column mb-4\">\n    <div class=\"card shadow-sm\">\n      <div class=\"w-100 d-flex justify-content-center bg-light\">\n        <h5 class=\"my-2\">\n          <b>Vermietung<\/b>\n        <\/h5>\n      <\/div>\n      <div class=\"table-responsive\">\n        <table class=\"table mb-0\">\n          <thead>\n            <tr>\n              <th><\/th>\n              <th>1-3 Bilder<\/th>\n              <th>4-6 Bilder<\/th>\n              <th>>6 Bilder<\/th>\n            <\/tr>\n          <\/thead>\n          <tbody>\n            <tr>\n              <th>S<\/th>\n              <td>3,00\u20ac<\/td>\n              <td>2,50\u20ac<\/td>\n              <td>2,00\u20ac<\/td>\n            <\/tr>\n            <tr>\n              <th>M<\/th>\n              <td>3,50\u20ac<\/td>\n              <td>3,00\u20ac<\/td>\n              <td>2,50\u20ac<\/td>\n            <\/tr>\n            <tr>\n              <th>L<\/th>\n              <td>4,00\u20ac<\/td>\n              <td>3,50\u20ac<\/td>\n              <td>3,00\u20ac<\/td>\n            <\/tr>\n            <tr>\n              <th>S<\/th>\n              <td>5,50\u20ac<\/td>\n              <td>5,00\u20ac<\/td>\n              <td>4,50\u20ac<\/td>\n            <\/tr>\n            <tr>\n              <th>S<\/th>\n              <td>3,00\u20ac<\/td>\n              <td>2,50\u20ac<\/td>\n              <td>2,00\u20ac<\/td>\n            <\/tr>\n          <\/tbody>\n        <\/table>\n      <\/div>\n    <\/div>\n    <small class=\"mx-auto mt-2\">Preis pro Bild pro Monat, inklusive Rahmen<\/small>\n  <\/div>\n<\/div>\n\n<!-- Desktop tables -->\n<div class=\"row justify-content-center my-3 d-none d-sm-flex\">\n  <div class=\"col mb-4\">\n    <div class=\"card shadow-sm\" >\n      <div class=\"w-100 d-flex justify-content-center bg-light\">\n        <h5 class=\"my-2\">\n          <b>Verkauf<\/b>\n        <\/h5>\n      <\/div>\n      <div class=\"table-responsive\">\n        <table class=\"table mb-0\">\n          <thead>\n            <tr>\n              <th><\/th>\n              <th>S<\/th>\n              <th>M<\/th>\n              <th>L<\/th>\n              <th>XL<\/th>\n              <th>XXL<\/th>\n            <\/tr>\n          <\/thead>\n          <tbody>\n            <tr>\n              <th>Ohne Rahmen<\/th>\n              <td>8\u20ac<\/td>\n              <td>14\u20ac<\/td>\n              <td>22\u20ac<\/td>\n              <td>27\u20ac<\/td>\n              <td>32\u20ac<\/td>\n            <\/tr>\n            <tr>\n              <th>Mit Rahmen<\/th>\n              <td>-<\/td>\n              <td>24\u20ac<\/td>\n              <td>40\u20ac<\/td>\n              <td>48\u20ac<\/td>\n              <td>57\u20ac<\/td>\n            <\/tr>\n          <\/tbody>\n        <\/table>\n      <\/div>\n    <\/div>\n  <\/div>\n  <div class=\"col d-flex justify-content-center flex-column mb-4\">\n    <div class=\"card shadow-sm\">\n      <div class=\"w-100 d-flex justify-content-center bg-light\">\n        <h5 class=\"my-2\">\n          <b>Vermietung<\/b>\n        <\/h5>\n      <\/div>\n      <div class=\"table-responsive\">\n        <table class=\"table mb-0\">\n          <thead>\n            <tr>\n              <th><\/th>\n              <th>S<\/th>\n              <th>M<\/th>\n              <th>L<\/th>\n              <th>XL<\/th>\n            <\/tr>\n          <\/thead>\n          <tbody>\n            <tr>\n              <th>1-3 Bilder<\/th>\n              <td>3,00\u20ac<\/td>\n              <td>3,50\u20ac<\/td>\n              <td>4,00\u20ac<\/td>\n              <td>5,50\u20ac<\/td>\n            <\/tr>\n            <tr>\n              <th>4-6 Bilder<\/th>\n              <td>2,50\u20ac<\/td>\n              <td>3,00\u20ac<\/td>\n              <td>3,50\u20ac<\/td>\n              <td>5,00\u20ac<\/td>\n            <\/tr>\n            <tr>\n              <th>>6 Bilder<\/th>\n              <td>2,00\u20ac<\/td>\n              <td>2,50\u20ac<\/td>\n              <td>3,00\u20ac<\/td>\n              <td>4,50\u20ac<\/td>\n            <\/tr>\n          <\/tbody>\n        <\/table>\n      <\/div>\n    <\/div>\n    <small class=\"mx-auto mt-2\">Preis pro Bild pro Monat, inklusive Rahmen<\/small>\n  <\/div>\n<\/div>\n\n<div class=\"mb-4 row justify-content-center\">\n  <div class=\"col col-auto\">\n    <b>Gr\u00f6\u00dfen (in cm):<\/b>\n  <\/div>\n  <div class=\"col col-auto\">\n    S: 20x30\n  <\/div>\n  <div class=\"col col-auto\">\n    M: 30x40-45\n  <\/div>\n  <div class=\"col col-auto\">\n    L: 40x50-60\n  <\/div>\n  <div class=\"col col-auto\">\n    XL: 50x60-75\n  <\/div>\n  <div class=\"col col-auto\">\n    XXL: 60x75\n  <\/div>\n<\/div>\n\n<div class=\"w-100 d-flex justify-content-center\">\n  <div class=\"card mt-3 mb-2 p-3 d-inline-flex flex-row align-items-center bg-light shadow-sm\">\n    <svg xmlns=\"http:\/\/www.w3.org\/2000\/svg\" width=\"16\" height=\"16\" fill=\"currentColor\" class=\"bi bi-info-circle\" viewBox=\"0 0 16 16\">\n      <path d=\"M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z\"\/>\n      <path d=\"m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z\"\/>\n    <\/svg>\n    <div class=\"ml-3 d-inline-block\" style=\"line-height: 0.9\">\n      <p class=\"mb-2\">\n        <small>Alle Preise zuz\u00fcglich Versandkosten<\/small>\n      <\/p>\n      <p class=\"mb-1\">\n        <small>Preise von Kunstwerken werden individuell bestimmt<\/small>\n      <\/p>\n    <\/div>\n  <\/div>\n<\/div>\n  "}
			}

      this.fetchingArticle = false;
    },
	}
}
</script>

<style scoped>
th, td {
  text-align: center !important;   
}
</style>